import { Action, InitialFiltersProductsTypes } from '@state/actions/Type';
import { InitialFilter, getInitialState } from '../initial-filter/InitialFiltersReducer';

export interface InitialFiltersProductsState {
  initialFilters: InitialFilter[];
}

const InitialFiltersProductsReducer = (
  state: InitialFiltersProductsState = getInitialState(), // NOSONAR typescript:S1788
  action: Action,
) => {
  if (action.type === InitialFiltersProductsTypes.InitialFiltersProductsUpdate) {
    return {
      ...state,
      initialFilters: action.payload.initialFilters,
    };
  }
  return state;
};

export default InitialFiltersProductsReducer;
